import { render } from "./JHMonogram.vue?vue&type=template&id=496a3649"
import script from "./JHMonogram.vue?vue&type=script&lang=js"
export * from "./JHMonogram.vue?vue&type=script&lang=js"

import "./JHMonogram.vue?vue&type=style&index=0&id=496a3649&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__